import isNumber from 'lodash/isNumber';
import get from 'lodash/get';

const updateImageDataOnPercentileChange = ({ payload, images }) => {
    const { imageFile, progressEventData } = payload;
    const { loaded, total } = progressEventData;

    let needToUpdateStore = false;
    if (isNumber(loaded) && isNumber(total)) {
        const percentile = Math.floor((loaded * 100) / total);
        for (let i = 0; i < images.length; i++) {
            if (get(imageFile, 'fileId', false) === get(images[i], 'id', null)) {
                if (percentile !== get(images[i], 'uploaded_percentile', false)) {
                    needToUpdateStore = true;
                    images[i] = {
                        ...images[i],
                        uploaded_percentile: percentile
                    }
                }
                break;
            }
        }
    }
    return {
        needToUpdateStore,
        updatedImages: images
    }
};

export default updateImageDataOnPercentileChange;
